// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbs_a bht_i bht_q bht_j"};